import React, { useState } from "react";
import "../ViewAssignment/ViewAssignment.css";

const API_URL = "https://aadyaacademy.org:5000";

const ViewAssignment = ({ assignment, closeDetail }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Format date to dd/mm/yyyy
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Construct URL for attachment
  const getAttachmentUrl = (url) => {
    if (!url) return null;
    // Check if the URL is already a full URL
    if (url.startsWith("https://") || url.startsWith("https://")) {
      return url;
    }
    // Otherwise, append to the API URL
    return `${API_URL}/${url}`;
  };

  if (loading) {
    return (
      <div className="view-container">
        <h2>Loading...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="view-container">
        <h2>{error}</h2>
      </div>
    );
  }

  if (!assignment) {
    return (
      <div className="view-container">
        <h2>Assignment not found.</h2>
        <button onClick={closeDetail} className="view-cancel">
          Close
        </button>
      </div>
    );
  }

  return (
    <div className="view-container">
      <div className="view-header">
        <h2>Assignment Details</h2>
      </div>
      <div className="view-details">
        
        <p>
          <strong>Grade:</strong> {assignment.class}
        </p>
        <p>
          <strong>Section:</strong> {assignment.section}
        </p>
        <p>
          <strong>Subject:</strong> {assignment.subject}
        </p>
        <p>
          <strong>Date:</strong> {formatDate(assignment.date)}
        </p>
        <p>
          <strong>Attachment:</strong>{" "}
          {assignment.attachmentUrl ? (
            <a
              href={getAttachmentUrl(assignment.attachmentUrl)}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Attachment
            </a>
          ) : (
            "None"
          )}
        </p>
        <div className="view-actions">
          <button onClick={closeDetail} className="view-cancel">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewAssignment;
